import { createContext, useContext } from 'react';

export type AvatarFilterType = {
  tenant: string;
  organization: string;
  category: string;
  gender: string;
  status: string;
};

export type AvatarUploadContextType = {
  filters: AvatarFilterType;
  areAllSelected: boolean;
  selectedAvatarFileIds: string[];
  onFilterChange: (id: string, value: string) => void;
  resetFilters: () => void;
  deleteModal: {
    onDelete: () => void;
    loading: boolean;
  };
  onAvatarDelete: (fileIds: string | string[]) => void;
  toggleAvatar: (type: 'single' | 'all', fileId?: string) => void;
  onRefresh: () => void;
};

const noop = () => {};

export const defaultValues: AvatarUploadContextType = {
  filters: {
    tenant: '',
    category: '',
    organization: '',
    gender: '',
    status: '',
  },
  areAllSelected: false,
  selectedAvatarFileIds: [],
  deleteModal: {
    onDelete: noop,
    loading: false,
  },
  onFilterChange: noop,
  resetFilters: noop,
  onAvatarDelete: noop,
  toggleAvatar: noop,
  onRefresh: noop,
};

export const AvatarUploadContext = createContext<AvatarUploadContextType>({
  ...defaultValues,
});

export const useAvatarUploadContext = (): AvatarUploadContextType =>
  useContext(AvatarUploadContext);
